import { AbstractControl, ValidatorFn } from '@angular/forms'

export function companyValidator(oppositeCtrl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const controlValue: any = control.value;
        const oppositeCtrlValue: any = oppositeCtrl.value;

        if (controlValue === -1 && (oppositeCtrlValue === '' || oppositeCtrlValue === null)) {
            return {required: true};
        }
        return null;
    }
}
